module.exports = __webpack_public_path__ + "img/error.9ef0e66e.png";